import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "../../Styles/Components/PricingPage.scss"; // Import SCSS file

const ScrollWidget = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false); // Track screen size

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768); // Detect if screen is mobile
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Automatically change slides every 5 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, 10000); // 10 000ms = 10 seconds

    return () => clearInterval(intervalId); // Clear interval on component unmount
  }, []);

  const items = [
    {
      title: "Smart IP Phones for Business Calls",
      description:
        "Stay connected and work anywhere.<br>" +
        "See customer details, track peak call times, and make<br> calls easily." +
        " NxaTel’s IP phones keep your team<br> responsive and efficient.",
      buttonText: "Browse Phones",
      image: "..\\assets\\images\\new_pricing\\deskphone.webp",
    },
    {
      title: "Fast, Reliable Internet for Your Business",
      description:
        "Stay connected with high-speed, secure, and<br>" +
        "scalable internet solutions. NxaTel ensures<br>" +
        " uninterrupted service for remote teams, offices, and <br>" +
        "growing businesses ",
      buttonText: "Get Connected",
      image: "..\\assets\\images\\new_pricing\\Router.webp",
    },
    {
      title: "Seamless Mobility for Business Calls Anywhere",
      description:
        "NxaTel’s mobility solution combines mobile network,<br>" +
        "voice services with a business phone, app, and headset <br>" +
        "—giving you reliable, high-quality calls anywhere, <br>" +
        "anytime, on any device.",
      buttonText: "Browse Phones",
      image: "..\\assets\\images\\new_pricing\\mobileheadset.webp",
    },
  ];

  const currentItem = items[currentIndex];

  return (
    <section className="scroll-widget">
      <div className="scroll-widget__content">
        <div className="scroll-widget__text">
          <h2>{currentItem.title}</h2>

          {/* Conditional Rendering: Different for Mobile & Desktop */}
          {isMobile ? (
            <p className="scroll-widget__description">
              {currentItem.description.replace(/<br>/g, " ")}
            </p>
          ) : (
            <div
              className="scroll-widget__description"
              dangerouslySetInnerHTML={{ __html: currentItem.description }}
            />
          )}

          <button className="scroll-widget__button">
            {currentItem.buttonText}
          </button>
        </div>

        <div className="scroll-widget__image">
          <img src={currentItem.image} alt={currentItem.title} />
        </div>
      </div>

      <div className="scroll-widget__navigation">
        {items.map((_, index) => (
          <motion.div
            key={index}
            className={`scroll-widget__dot ${
              index === currentIndex ? "active" : ""
            }`}
          ></motion.div>
        ))}
      </div>
    </section>
  );
};

export default ScrollWidget;
